import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { LeaderboardScores } from 'api';

import LeaderboardTableRow from './TableRow';

interface IProps extends WithStyles<typeof styles> {
  items: LeaderboardScores['items'];
}

const styles = (theme: Theme) =>
  createStyles({
    head: {
      height: theme.spacing(4),
    },
    emptyCell: {
      padding: `${theme.spacing(1)}px 0`,
    },
  });

const LeaderboardTable: FC<IProps> = ({ classes, items }) => {
  const { t } = useTranslation();
  const cellClasses = { head: classes.head };

  return (
    <Table size="medium">
      <TableHead>
        <TableRow>
          <TableCell colSpan={4} padding="none" classes={cellClasses}>
            {t('common:leader_plural')}
          </TableCell>
          <TableCell align="right" padding="none" classes={cellClasses}>
            {t('common:point_plural')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {!items.length && (
          <TableRow>
            <TableCell className={classes.emptyCell} colSpan={5}>
              <em>{t('components:noLeaderboardResults')}</em>
            </TableCell>
          </TableRow>
        )}
        {items.map(item => (
          <LeaderboardTableRow key={item.user_id} row={item} />
        ))}
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(LeaderboardTable);
